import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { useDwindle } from '../../utils/Hooks.js';
import { ActionButtonPresentation, defaultProps } from './ActionButtonPresentation.js';

var ActionButtonWrapper = function ActionButtonWrapper(props) {
  var _useDwindle = useDwindle(props),
    _useDwindle2 = _slicedToArray(_useDwindle, 3),
    _useDwindle2$ = _useDwindle2[0],
    hasKeyboardFocus = _useDwindle2$.hasKeyboardFocus,
    hasMouseHover = _useDwindle2$.hasMouseHover,
    clicked = _useDwindle2$.clicked,
    _useDwindle2$2 = _useDwindle2[1],
    setHasKeyboardFocus = _useDwindle2$2.setHasKeyboardFocus,
    setHasMouseHover = _useDwindle2$2.setHasMouseHover,
    _useDwindle2$3 = _useDwindle2[2],
    onMouseDown = _useDwindle2$3.onMouseDown,
    onMouseUp = _useDwindle2$3.onMouseUp,
    onMouseLeave = _useDwindle2$3.onMouseLeave;
  return /*#__PURE__*/React.createElement(ActionButtonPresentation, Object.assign({}, props, {
    hasKeyboardFocus: hasKeyboardFocus,
    onKeyboardFocusChange: setHasKeyboardFocus,
    hasMouseHover: hasMouseHover,
    onMouseHoverChange: setHasMouseHover,
    onMouseDown: onMouseDown,
    onMouseUp: onMouseUp,
    onMouseLeave: onMouseLeave,
    clicked: clicked
  }));
};
ActionButtonWrapper.defaultProps = defaultProps;

export { ActionButtonWrapper };
